var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9925 17.037C20.9905 17.109 20.9695 17.177 20.9505 17.246C20.9355 17.304 20.9285 17.363 20.9035 17.416C20.8805 17.468 20.8415 17.51 20.8075 17.558C20.7655 17.619 20.7275 17.68 20.6735 17.73C20.6645 17.739 20.6605 17.751 20.6505 17.759C20.6145 17.79 20.5705 17.801 20.5315 17.826C20.4715 17.865 20.4125 17.905 20.3445 17.931C20.2775 17.955 20.2115 17.961 20.1425 17.971C20.0945 17.978 20.0515 18 20.0005 18H15.0005C14.4475 18 14.0005 17.552 14.0005 17C14.0005 16.448 14.4475 16 15.0005 16H17.8265L13.7905 11.292L9.5145 13.857C9.0915 14.113 8.5475 14.019 8.2315 13.64L3.2315 7.64C2.8785 7.216 2.9355 6.585 3.3595 6.232C3.5475 6.076 3.7735 6 3.9995 6C4.2865 6 4.5705 6.122 4.7685 6.36L9.2205 11.702L13.4855 9.142C13.9045 8.891 14.4425 8.979 14.7595 9.349L19.0005 14.297V12C19.0005 11.448 19.4475 11 20.0005 11C20.5535 11 21.0005 11.448 21.0005 12V17C21.0005 17.013 20.9935 17.024 20.9925 17.037Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingDown);
export default __webpack_public_path__ + "static/media/TrendingDown.426ba659cdae8fcf9a5f92b5c6f0efbc.svg";
export { ForwardRef as ReactComponent };